// Shared client-side input shape checks.
//
// These are PRAGMATIC pre-flight checks, not a specification of what a valid
// address is: the server stays the authority and still rejects with a 400. The
// point is to stop a request that provably cannot succeed — an empty field, a
// missing @ — before it costs a round-trip and, worse, before the caller renders
// a success panel for it.
//
// One regex, three consumers (LoginPage, RecoveryPage, the AdminUsers invite
// form). It lived only in AdminUsersPage while the two pre-auth pages had no
// check at all, which is exactly how they came to report success for input that
// never produced a valid request.

/**
 * A deliberately loose email shape check: something, an @, something, a dot,
 * something — with no whitespace anywhere. It is not RFC 5322 and should not
 * grow toward it; over-strict client regexes reject deliverable addresses.
 */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** True when `value` (trimmed) has a plausible email shape. */
export function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(value.trim());
}
